import * as React from 'react';
import BookmarkListItem from './bookmarkListItem';

export default function BookmarkGroup({ category, toggleCategorizeModal  }) {
    const [expanded, setExpanded] = React.useState(
        category.categoryName === "Okategoriserat"
    );

    return (
        <li className="bookmarks__border">
            <div
                className="bookmarks__item  bookmarks__item--clickable"
                tabIndex={0}
                onKeyUp={(e) => { e.key === 'Enter' && setExpanded(!expanded) }}
                onClick={() => { setExpanded(!expanded) }}
                aria-expanded={expanded ? "true" : 'false'}
                role="button"
            >
                <div className="bookmarks__link  bookmarks__link--heading">{category.categoryName}</div>
                <div>
                    <div className="bookmarks__amount">{category.bookmarks.length}</div>
                </div>
                <div className={`bookmarks__arrow  ${expanded && 'bookmarks__arrow--up'}`}></div>
            </div>
            <ul className="bookmarks__sublist">
                {expanded && category.bookmarks.map((bookmark) => (
                    <BookmarkListItem
                        key={bookmark.id}
                        bookmark={bookmark}
                        onButtonClick={(event) =>
                            toggleCategorizeModal(event, bookmark.id, bookmark.title, bookmark.categoryId)
                        }
                    />
                ))}
            </ul>
        </li>
    )
}